export default __webpack_public_path__ + "static/media/image-eyecam.74f66bf4.jpg";